var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo1159({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 91,
    viewBox: "0 0 102 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#2437a8;}.b,.c,.d,.e,.f,.h{fill-rule:evenodd;}.c{fill:#cf3e83;}.d{fill:#f2bfe4;}.e{fill:#405fd3;}.f{fill:#0d0b6d;}.g{fill:none;stroke:#1c295e;}.h{opacity:0.403;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3806 -1482)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3806 1482)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 46,
    cy: 45.5,
    rx: 46,
    ry: 45.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3818.204 1485.496)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.864,84.868c0,17.607,13.624,31.881,30.432,31.881s30.432-14.273,30.432-31.881S146.578,54,129.771,54,97.864,67.261,97.864,84.868",
    transform: "translate(-97.864 -54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.155,74.345A3.294,3.294,0,0,1,39.829,68.1a25.119,25.119,0,0,1,10.645-2.686c8.647-.3,22.334,6.046,24.855,20.109,2.811,15.677-8.607,23,1.732,36.148l-28.17,10s-5.267-8.919.746-22.221c5.385-11.914,13.548-34.5-8.481-35.106",
    transform: "translate(12.736 -59.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M148.54,184.217s6.25.185,8.913-1.27l-8.581,5.387Z",
    transform: "translate(-121.081 -120.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M127.616,136.637c3.185,2.117,8.985,2.378,13.929,2.093l1.131,14.04,16.133-6.641s-1.551-15.495-2.224-21.435c3.243-2.938,8.768-4.3,8.777-9.294a4.536,4.536,0,0,0-4.741-4.732c-5.007,0-4.292,6-4.292,6-5.665,2.2-11.459-16.834-14.8-21.145-1.827-2.359-15.852,2.919-15.852,2.919l-7.96,8.9c-.155,1.1.406,22.981,9.9,29.293",
    transform: "translate(-114.085 -75.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M197.482,139.894l-3.576,8.67,4.149-.083Z",
    transform: "translate(-183.609 -98.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M178.457,137.186c.089,1.732,1.108,3.082,2.275,3.014s2.042-1.526,1.953-3.258-1.108-3.082-2.275-3.014-2.042,1.526-1.953,3.258",
    transform: "translate(-160.776 -95.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M201.144,136.614c.089,1.732,1.108,3.082,2.275,3.014s2.042-1.526,1.953-3.258-1.108-3.082-2.275-3.015-2.042,1.526-1.953,3.258",
    transform: "translate(-194.428 -95.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M180.6,163.968s2.7.873,5.413-2.14",
    transform: "translate(-165.136 -109.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M148.518,184.217s6.249.185,8.913-1.271l-8.581,5.387Z",
    transform: "translate(-121.049 -120.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M169.107,110s-21.543,1.807-32.713-23.672l24.686-4.313",
    transform: "translate(-126.865 -68.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M207.513,83.654s.025,17.746-10.038,26.57l-1.14-11.3",
    transform: "translate(-194.241 -69.322)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo1159);
export default __webpack_public_path__ + "static/media/Grupo 1159.b98a75b322ed6172df48cf79d82cb668.svg";
export { ForwardRef as ReactComponent };